module.exports = require("jpeg-js");